import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';

export const validate = (preSelectedIds, selectedIds) => checkDiff(preSelectedIds, selectedIds);
